import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHistory: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHistory"><Path fillRule="evenodd" clipRule="evenodd" d="M4 5.99932V4H2V10H8V8H5.06997C6.45395 5.60755 9.04015 4 12 4C16.4182 4 20 7.58172 20 12C20 16.4183 16.4182 20 12 20C8.51828 20 5.55363 17.7753 4.45492 14.6668L4.12168 13.7239L2.236 14.3904L2.56925 15.3332C3.94156 19.2159 7.64434 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C8.72763 2 5.82381 3.57164 4 5.99932ZM13 7V11.5858L16.4142 15L15 16.4142L11 12.4142V7H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHistory;
